import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const [handle, setHandle] = useState('');
  const { login, loading, error, isAuthenticated } = useAuth();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const returnUrl = queryParams.get('returnUrl') || '/';

  useEffect(() => {
    if (isAuthenticated) {
      setTimeout(() => {
        window.location.replace(returnUrl);
      }, 100);
    }
  }, [isAuthenticated, returnUrl]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    localStorage.setItem('auth_redirect_url', returnUrl);
    await login(handle || null, returnUrl);
  };

  if (isAuthenticated) {
    return (
      <div className="login-container login-status">
        <p>Already logged in. Redirecting to {returnUrl}...</p>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-content">
        <h1>Log in to Sifter</h1>
        <p>Enter your Bluesky or ATProto handle</p>
        <form onSubmit={handleSubmit} className="login-form">
          <input
            type="text"
            value={handle}
            onChange={(e) => setHandle(e.target.value)}
            placeholder="username.bsky.social"
            aria-label="Bluesky Handle (optional)"
            className="login-input-field"
            disabled={loading}
          />
          {loading && <p className="login-status-message">Processing...</p>}
          {error && <p className="login-error-message">Login failed: {error}</p>}
          <button
            type="submit"
            disabled={loading || isAuthenticated}
            className="login-submit-button"
          >
            {loading ? 'Processing...' : 'Log in with Bluesky'}
          </button>
        </form>
        <p className="login-explainer">
          Sifter scans your account for blobs your PDS holds that no record
          references, lets you review and back them up, and — if you choose —
          removes them.
        </p>
        <p className="login-honest-note">
          Most accounts have zero orphans. This tool mostly exists to prove that.
        </p>
        <p className="login-privacy-note">
          We use official Bluesky/ATProto OAuth to securely process your login.
          Sifter needs repo write access because its cleanup mechanism briefly
          creates and deletes a throwaway record for each blob.
        </p>
      </div>
    </div>
  );
};

export default Login;
